import React, { Component } from "react";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router/dom";
import { PageMetadataProvider } from "./components/app/PageMetadata";
import createStore from "./createStore";
import { appRouter } from "./routing/router";
import "./styles";

const initialState = window.___INITIAL_STATE__;
const store = createStore(initialState);

class App extends Component {
  render() {
    return (
      <PageMetadataProvider>
        <Provider store={store}>
          <RouterProvider router={appRouter} />
        </Provider>
      </PageMetadataProvider>
    );
  }
}

export default App;
